module.exports = __webpack_public_path__ + "static/media/md-planet.8dba5e77.svg";